import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import styles from '~/components/SecureLoginModal/SecureLoginModal.module.scss';
import { routes } from '~/constants';
export const LoginErrorModal = ()=>{
    const overlayContext = useOverlayContext();
    const history = useHistory();
    const location = useLocation();
    useEffect(()=>{
        const baseRoute = location.pathname.replace(routes.loginError, '');
        let updatedDismissModal;
        overlayContext.showModal({
            content: (param)=>{
                let { dismissModal } = param;
                updatedDismissModal = dismissModal;
                return /*#__PURE__*/ _jsx(ActualLoginErrorModal, {
                    dismissModal: updatedDismissModal
                });
            },
            closeOnClickOutside: true,
            closeOnEscapeKey: true
        }).then(()=>{
            history.replace(baseRoute);
        });
        return ()=>{
            if (updatedDismissModal) {
                updatedDismissModal(false);
            }
        };
    }, []);
    return null;
};
export const ActualLoginErrorModal = (param)=>{
    let { dismissModal } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        testId: "login-error-modal",
        title: "Something went wrong",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.secureLoginModalContainer,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: "The email address associated with this account is different from the one you tried to login with."
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: "To set up a secure login, you must use the same email address."
                }),
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx(Typography, {
                    children: "You can always open a Service Provider account using a different email address through www.sayanchor.com"
                })
            ]
        }),
        onCloseButtonClick: ()=>dismissModal(false),
        primaryButtonLabel: "",
        onPrimaryButtonClick: ()=>dismissModal(true),
        secondaryButtonLabel: "Back",
        onSecondaryButtonClick: ()=>dismissModal(false)
    });
};
